<template>
  <selection-dialog
    v-model="show"
    :title="modalTitle"
    :confirm-disabled="subOrderCancelReason == undefined || (subOrderCancelReason == 'other' && otherChoice.trim() == '')"
    @confirm="onConfirm"
    @close="$emit('close')"
  >
    <v-card-text class="pb-0">{{ modalIntroSentence }}</v-card-text>
    <v-radio-group v-model="subOrderCancelReason" column>
      <v-radio
        v-for="choice of choices"
        v-bind:key="choice.value"
        :label="choice.text"
        :value="choice.value"
      ></v-radio>
      <v-text-field
        dense
        v-model="otherChoice"
        v-if="subOrderCancelReason == 'other'"
        :placeholder="$t('subOrder.pleaseSpecify')"
      ></v-text-field>
    </v-radio-group>
    <slot name="admin-options"></slot>
  </selection-dialog>
</template>

<script>
  import SelectionDialog from './dialogs/SelectionDialog.vue'

  export default {
    name: 'MultipleChoicesDialog',
    components: { SelectionDialog },
    data() {
      let { subOrderCancelReasonInitialValue, otherChoiceInitialValue } = this.initData(this.previousReason)
      return {
        otherChoice: otherChoiceInitialValue,
        subOrderCancelReason: subOrderCancelReasonInitialValue,
      }
    },
    props: {
      title: {
        type: String,
        default: undefined,
      },
      introductionSentence: {
        type: String,
        default: undefined,
      },
      value: {
        type: Boolean,
        default: false,
      },
      choices: {
        type: Array,
        required: true,
      },
      previousReason: {
        type: String,
        default: undefined,
      },
    },
    computed: {
      show: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        },
      },
      modalTitle() {
        return this.title || this.$t('components.modalMultipleChoices.defaultTitle')
      },
      modalIntroSentence() {
        return this.introductionSentence || this.$t('components.modalMultipleChoices.defaultText')
      },
    },
    methods: {
      onConfirm() {
        if (this.subOrderCancelReason == 'other' && this.otherChoice.trim() != '') {
          this.$emit('confirm', this.otherChoice)
        } else {
          this.$emit('confirm', this.subOrderCancelReason)
        }
      },
      initData(previousReason) {
        if (previousReason && !this.choices.some((choice) => choice.value == previousReason)) {
          return { subOrderCancelReasonInitialValue: 'other', otherChoiceInitialValue: previousReason }
        } else {
          return { subOrderCancelReasonInitialValue: previousReason, otherChoiceInitialValue: '' }
        }
      },
    },
  }
</script>
